/**
 * NAT 방화벽 Batch File
 *
 * @since 2018-10-19
 * @author kdydesign.kim
 */
import {
  CommonApiPrefix as cmnApiPrefix,
  SecutiryPolicyApiPrefix as poApiPrefix
} from 'utils'

// 방화벽 정책 - 배치 입력 데이터
const initNatBatchData = () => {
  return {
    file: void 0,
    excel_pos: 1,
    allow_dup: 1,
    pre_rule_id: void 0
  }
}

export const state = () => ({
  upLoadFile: void 0,
  natBatchData: initNatBatchData()
})

export const mutations = {
  // 배치 데이터 초기화
  resetNatBatchData (state) {
    state.natBatchData = initNatBatchData()
    state.upLoadFile = void 0
  },

  // 파일 업로드
  fileUpload (state, {file}) {
    state.upLoadFile = file
  }
}

export const actions = {
  // 파일 업로드
  async fileUpload ({commit, state, dispatch}, {formData}) {
    const {code, result} = await this.$axios.$post(`${cmnApiPrefix}/file/import`, formData)

    if (code === 'ok') {
      commit('fileUpload', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // 배치 실행
  async runAddNatBatch ({commit, state, dispatch}) {
    const {code, result} = await this.$axios.$post(`${poApiPrefix}/nat/rules/batch`, _.assign(state.natBatchData, {
      file: state.upLoadFile
    }))

    if (code === 'async') {
      dispatch('common/common/setIsChanged', true, {root: true})
      return result.id
    }
  }
}

export const getters = {}

export const strict = false
